export default __webpack_public_path__ + "static/media/Dr. Subhashree Panda.e1a3467b.png";